import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';

export async function getAllLocations() {
  try {
    const url = `${constants.endpoints.LOCATIONS_MANAGEMENT}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch locations failed', error.message);
    throw error;
  }
}

export async function createLocation(data) {
  try {
    const response = await getInstance().post(constants.endpoints.LOCATIONS_MANAGEMENT, data);
    return response.data;
  } catch (error) {
    console.error('Create location failed', error.message);
    throw error;
  }
}